import { TAB_CLASS_NAME } from "Common/componentUtils/constants";
import classNames from "classnames";
import isString from "lodash/isString";
import React, { useCallback, useMemo } from "react";
export default function Tab(props) {
    const handleClick = useCallback(() => {
        props.onClick && props.onClick(props.index);
    }, [props.index, props.onClick]);
    const style = useMemo(() => ({
        opacity: props.disabled ? "0.7" : "1",
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "default" : "pointer",
        textDecoration: "none"
    }), [props.disabled]);
    return (React.createElement("a", { ref: props.tabRef, title: isString(props.title) ? props.title : undefined, className: classNames(TAB_CLASS_NAME, "d-inline-block", props.className, props.active && "active"), style: style, onClick: handleClick }, props.title));
}
Tab.defaultProps = {
    active: false,
    disabled: false,
    index: 0
};
